import { Component, OnInit } from "@angular/core";
import {
  DynamicDialogConfig,
  DynamicDialogRef,
  MessageService,
} from "primeng/api";

import { RmaindersInterface } from "./remainder.interface";
import { RemaindersService } from "./service/api/remainders.service";

@Component({
  selector: "app-remainders",
  templateUrl: "./remainders.component.html",
  styleUrls: ["./remainders.component.scss"],
  providers: [MessageService],
})
export class RemaindersComponent implements OnInit {
  _remaindersData: any;
  remaindersObj: RmaindersInterface;
  minimunDate = new Date();

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private service: RemaindersService,
    private toast: MessageService
  ) {
    this._remaindersData = this.config.data;
    this.remaindersObj = {};
  }

  saveRemainder() {
    this.remaindersObj = {
      entityType: this._remaindersData.entityType,
      registerBook: this._remaindersData.registerBookId,
      scheduleBook: this._remaindersData.scheduleBookId,
      complain: this._remaindersData.complainId,
      daura: this._remaindersData.dauraId,
      vikasKame: this._remaindersData.vikasKamId,
      visitor: this._remaindersData.visitorId,
      remainderDate: this.remaindersObj.remainderDate,

      // remainderDate: this.dateFormat(this.remaindersObj.remainderDate),
      notes: this.remaindersObj.notes,
    };
    this.service.remaindersCreate(this.remaindersObj).subscribe((res: any) => {
      this.toast.add({
        severity: "success",
        summary: "Set Successfully",
        detail: "Reminder Set Successfully !!!",
      });
      setTimeout(() => {
        this.ref.close();
      }, 1000);
    });
  }

  dateFormat(recievedDate) {
    let date = recievedDate;
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();
    recievedDate =
      y + "-" + (m <= 9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d);
    return recievedDate;
  }

  ngOnInit() {}
}
